import {
  Button,
  Dialog,
  DialogActions,
  DialogCloseButton,
  DialogCloseIcon,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from 'components/ui';
import { DAILY_NAV_SETUP_TEST_IDS } from '../DailyNavSetup.testIds';

type LeaveWithUnsavedChangesDialogProps = {
  open: boolean;
  body: string;
  isSaving?: boolean;
  onKeepEditing: () => void;
  onDiscard: () => void;
  // Omitted where saving belongs elsewhere, e.g. the firm steps save only at step 3.
  onSaveAndLeave?: () => void;
};

const LeaveWithUnsavedChangesDialog = ({
  open,
  body,
  isSaving = false,
  onKeepEditing,
  onDiscard,
  onSaveAndLeave,
}: LeaveWithUnsavedChangesDialogProps) => (
  <Dialog
    open={open}
    onClose={isSaving ? undefined : onKeepEditing}
    maxWidth="xs"
    fullWidth
    data-testid={DAILY_NAV_SETUP_TEST_IDS.leaveDialog}>
    <DialogHeader>
      <DialogTitle>You have unsaved changes</DialogTitle>
      <DialogCloseButton aria-label="Keep editing" size="small" onClick={onKeepEditing} disabled={isSaving}>
        <DialogCloseIcon />
      </DialogCloseButton>
    </DialogHeader>
    <DialogContent>
      <DialogDescription>{body}</DialogDescription>
    </DialogContent>
    <DialogActions>
      <Button onClick={onKeepEditing} data-testid={DAILY_NAV_SETUP_TEST_IDS.leaveKeepEditingButton}>
        Keep editing
      </Button>
      <Button color="error" onClick={onDiscard} data-testid={DAILY_NAV_SETUP_TEST_IDS.leaveDiscardButton}>
        Discard
      </Button>
      {onSaveAndLeave && (
        <Button
          variant="contained"
          onClick={onSaveAndLeave}
          disabled={isSaving}
          loading={isSaving}
          data-testid={DAILY_NAV_SETUP_TEST_IDS.leaveSaveButton}>
          Save &amp; leave
        </Button>
      )}
    </DialogActions>
  </Dialog>
);

export default LeaveWithUnsavedChangesDialog;
